import PropTypes from "prop-types";
import React from "react";
import { Col, Container, Row } from "shards-react";

import MainFooter from "../components/layout/MainFooter";
import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";

const DefaultLayout = ({ children, noNavbar, noFooter }) => (
  <Container fluid>
    <Row>
      <MainSidebar />
      <Col
        className="main-content p-0"
        lg={{ size: 9, offset: 3 }}
        md={{ size: 8, offset: 4 }}
        sm="12"
        tag="main"
      >
        {!noNavbar && <MainNavbar />}
        
        <div className="containerGeneral">{children}</div>
        <MainFooter />
      </Col>
    </Row>
  </Container>
);

DefaultLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool
};

DefaultLayout.defaultProps = {
  noNavbar: false,
  noFooter: false
};

export default DefaultLayout;
